module.exports = __webpack_public_path__ + "img/hohlsaum_blau_candy.c159a94b.jpg";